import { unref as _unref, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/index/lightPoint.png';
import _imports_1 from '@/assets/img/index/hardwareInfra.svg';
import _imports_2 from '@/assets/img/index/dataSorting.svg';
import _imports_3 from '@/assets/img/index/modelTraining.svg';
import _imports_4 from '@/assets/img/index/flexibleDeployment.svg';
const _withScopeId = n => (_pushScopeId("data-v-44fe0810"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-page"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "content-title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "content-top"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}), /*#__PURE__*/_createElementVNode("p", null, " 构建了一套一站式的大模型训练方案，涵盖关键环节 ")]), /*#__PURE__*/_createElementVNode("div", {
  class: "con-cell"
}, [/*#__PURE__*/_createElementVNode("span", null, "硬件基础设施搭建"), /*#__PURE__*/_createElementVNode("span", null, "数据集整理"), /*#__PURE__*/_createElementVNode("span", null, "模型训练"), /*#__PURE__*/_createElementVNode("span", null, "模型部署等")])]), /*#__PURE__*/_createElementVNode("div", {
  class: "content-title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "content-top"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}), /*#__PURE__*/_createElementVNode("p", null, " 助力用户完成从数据准备到模型部署的全流程大模型训练任务 ")])])], -1));
const _hoisted_2 = {
  class: "back-agent"
};
const _hoisted_3 = {
  alt: ""
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "con-detail"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "detail-cell"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "img-icon",
  src: _imports_1,
  alt: ""
}), /*#__PURE__*/_createTextVNode(" 硬件基础设施 ")]), /*#__PURE__*/_createElementVNode("p", {
  class: "detail-cell"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "img-icon",
  src: _imports_2,
  alt: ""
}), /*#__PURE__*/_createTextVNode(" 数据整理 ")]), /*#__PURE__*/_createElementVNode("p", {
  class: "detail-cell"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "img-icon",
  src: _imports_3,
  alt: ""
}), /*#__PURE__*/_createTextVNode(" 多样化的模型训练 ")]), /*#__PURE__*/_createElementVNode("p", {
  class: "detail-cell"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "img-icon",
  src: _imports_4,
  alt: ""
}), /*#__PURE__*/_createTextVNode(" 灵活的模型部署 ")])], -1));
import agentCom from './agentCom.vue';
import { ref } from 'vue';
export default {
  __name: 'modelToCom',
  setup(__props, {
    expose: __expose
  }) {
    let pageActive = ref(false);
    __expose({
      pageActive
    });
    return (_ctx, _cache) => {
      const _directive_lazy = _resolveDirective("lazy");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(_unref(pageActive) ? 'safe-agent active ' : 'safe-agent')
      }, [_createVNode(agentCom, {
        showBotton: true,
        title: '模型定制化训练框架',
        pageUrl: '/modelTraining.html'
      }, {
        left: _withCtx(() => [_hoisted_1]),
        right: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_withDirectives(_createElementVNode("img", _hoisted_3, null, 512), [[_directive_lazy, require('@/assets/img/index/modelToComInst.svg')]])])]),
        bottom: _withCtx(() => [_hoisted_4]),
        _: 1
      })], 2);
    };
  }
};